import { Recipient } from '../../../data/types.generated';

export const getCurrentUser = (recipients: Recipient[], currentUserId: string): Recipient => {
    return recipients.find((recipient: Recipient): boolean => recipient.userId === currentUserId);
};
